require('./passwordResetService');

"use strict";

angular.module('app.passwordReset.passwordResetController', [
  'app.passwordReset.passwordResetService'
])
  .controller('app.passwordReset.passwordResetController', [
    '$scope',
    'app.passwordReset.passwordResetService',
    '$state',
    '$stateParams',
    function ($scope, passwordReset, $state, $stateParams) {
      $scope.email = null;
      $scope.error = null;
      $scope.message = $stateParams.message;

      let processResetRequestResponse = function (data) {
        if (data.error) {
          $scope.error = data.error;
        }
        else {
          $state.go('app.passwordReset.sent', {email: $scope.email});
        }
      };

      $scope.sendResetRequest = function () {
        passwordReset.sendResetRequest($scope.email)
          .then(
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              processResetRequestResponse(response.data);
            },
            /**
             * @param {HttpResponse} response
             */
            function (response) {
              processResetRequestResponse(response.data);
            }
          );
      }
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/passwordReset/passwordResetController.js